import Image from '@tiptap/extension-image';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import ResizableMediaView from './ResizableMediaView.vue';

export const ResizableImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: (element) => {
          // Percentage width from inline style
          const styleWidth = element.style.width;
          if (styleWidth?.endsWith('%')) {
            return styleWidth;
          }
          // Legacy pixel value — keep as-is, will be converted on next resize
          if (styleWidth) {
            return styleWidth;
          }
          const attrWidth = element.getAttribute('width');

          return attrWidth || null;
        },
        renderHTML: (attributes) => {
          if (!attributes.width) {
            return {};
          }

          return { style: `width: ${attributes.width}` };
        },
      },
    };
  },

  addNodeView() {
    return VueNodeViewRenderer(ResizableMediaView);
  },
});
